import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

export const LocationControls = ({ 
  userLocation,
  onCenterToLocation,
  onToggleLock = () => {},
  isLocked = false
}) => {
  const getButtonStyles = (active) => {
    if (active) return 'bg-blue-500 text-white';
    return 'bg-gray-700 text-gray-400 hover:bg-gray-600 hover:text-white';
  };

  return (
    <div className="flex flex-col space-y-1">
      <button
        onClick={onToggleLock}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(isLocked)}`}
        title={isLocked ? 'Unlock Map' : 'Lock Map'}
      >
        <span className="w-4 h-4">🔒</span>
        <span className="text-sm">Locked</span>
      </button>
      <button
        onClick={onCenterToLocation}
        className={`p-2 rounded-lg flex items-center gap-2 w-full ${getButtonStyles(false)}`}
        title="Center to Location"
      >
        <Navigation className="w-4 h-4" />
        <span className="text-sm">Center Map</span>
      </button>
    </div>
  );
};